import React from 'react';
import { PasscodeCardActions } from '~/components/shared/Passcode/PasscodeCardActions';
import { usePasscodeStatus } from '~/components/shared/Passcode/usePasscodeStatus';
import { useGoToNextStepCardOffer } from '../../hooks/useGoToNextStepCardOffer';

/**
 * Stays blank while the status request is still loading or has failed —
 * `PasscodeStep` owns the spinner and retry UI for that, and the design has
 * no footer button for either.
 */
export const PasscodeStepFooter = () => {
  const goToNextStep = useGoToNextStepCardOffer();
  const status = usePasscodeStatus();

  if (status.status !== 'ready') {
    return null;
  }

  return (
    <PasscodeCardActions
      hasExistingPasscode={status.hasExistingPasscode}
      onKeepExisting={goToNextStep}
      successAction={{
        label: 'CreatePasscode.SuccessButtonOffer',
        onClick: goToNextStep,
      }}
    />
  );
};
